import { useAppSelector } from 'shared';

export const usePortfolioEventsPageState = (
    () => useAppSelector((store) => store.portfolioEventsPage)
);
